import { codeGeneretor } from 'app/utils';

const TEMPLATE_NAME = 'PAD_MODEL_CREATOR';

const initialState = () => ({
  loading: false,
  padModel: {},
  isSubmitting: false,
  errors: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_SAVE_MODEL`: {
      const newData = action.payload;
      let padModel = newData.data;
      padModel.code = codeGeneretor();
      return {
        ...state,
        loading: false,
        padModel
      };
    }

    case `${TEMPLATE_NAME}_CREATE_PENDING`: {
      return {
        ...state,
        isSubmitting: true
      };
    }

    case `${TEMPLATE_NAME}_CREATE_REJECTED`: {
      return {
        ...state,
        isSubmitting: false
      };
    }

    case `${TEMPLATE_NAME}_CREATE_FULFILLED`: {
      return {
        ...state,
        isSubmitting: false
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
